export const columns = [
  {
    type: 'index',
    label: '序号',
    width: '55'
  },
  {
    prop: 'operationDate',
    label: '操作时间'
  },
  {
    prop: 'operationPerson',
    label: '操作人员',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'operationRole',
    label: '操作角色',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'operationColumn',
    label: '操作栏目'
  },
  {
    prop: 'operationFuncation',
    label: '操作功能'
  },
  {
    prop: 'operationEvent',
    label: '操作',
    align: 'left',
    headerAlign: 'center'
  }
];
